import { defineComponent, ref, reactive, SetupContext } from '@vue/composition-api';
import CommonMessageDialog from '@/components/common/common-message-dialog.component.vue';  // 共通メッセージダイアログコンポーネント
import vueRouter from '@/router/index';                                                     // ルート情報取得
import SystemConst from '@/shared/system-const';                                            // 定数定義
import HttpStatus from 'http-status-codes';                                                 // HTTPステータスコード取得用

// リアクティブな変数の型定義
export type reactiveData = {
    displayLink: boolean;
    outputPasswordDialog: boolean;
    isDownLoading: boolean;
};

/**
 * ユーザー管理（一括登録）：登録完了コンポーネント
 *
 * 登録完了画面を表示する。
 */
export default defineComponent({
    components: { CommonMessageDialog },
    setup(props, ctx: SetupContext) {
        const router = vueRouter;                                                // ルータ
        const stepper = <number>3;                                               // ステッパーの3段階目
        const commonRef = ref<any>(null);                                        // 共通ダイアログ
        const state: reactiveData = reactive<reactiveData>({
            displayLink: false,                                                  // パスワード情報ダウンロードリンク表示
            outputPasswordDialog: false,                                         // パスワード情報ダウンロードダイアログ
            isDownLoading: false                                                 // ファイルがダウンロード中: true ダウンロード中でない: false
        });
        // Excelファイル名格納
        const fileName = SystemConst.EXCEL_API_PARAM.BULK_ADD_USERS_PASSWORD_FILE;

        /**
         * created
         */
        created();
        async function created() {
            // titleIcon変更
            ctx.root.$store.commit('setTitleIcon', 'mdi-file-upload-outline');

            // mainTitle変更
            ctx.root.$store.commit('setMainTitle', 'ユーザー一括登録');
            
            // パスワード有無取得APIでパスワード有無を取得する
            // URL:GET /api/bulk-add-users/check-passwords
            // params:なし
            const response = await ctx.root.$store.dispatch('bulkAddUsers/existPasswords');

            // API通信が正常か
            if (response.status !== HttpStatus.OK) {
                // HTTPステータスコードが200以外の場合、errorDisplayTransitionControl()を呼ぶ
                // 引数にレスポンスを設定する
                commonRef.value.errorDisplayTransitionControl(response);
                return;
            }
            // パスワード有無がtrueの場合、state.displayLink = true;
            if (response.data.existPasswords === true) {
                state.displayLink = true;
            } else {
                state.displayLink = false;
            }
        }

        /**
         * パスワード情報EXCEL出力処理
         * 
         */
        async function outputPasswords() {
            // ローダーダイアログの表示をtrueにする
            state.outputPasswordDialog = true;

            // ファイルダウンロード中にローダーを表示する
            state.isDownLoading = true;

            // ユーザー一括登録storeのoutputPasswordsを呼び出す
            // パラメータ:Excelファイル名
            const response = await ctx.root.$store.dispatch('bulkAddUsers/outputPasswords',
                {
                    fileName
                });

            // ファイルダウンロード中表示するローダーを非表示にする
            state.isDownLoading = false;

            // ローダーダイアログの表示をfalseにする
            state.outputPasswordDialog = false;

            // API通信が正常か
            if (response.status !== HttpStatus.OK) {
                // 正常でない場合エラー画面を表示する
                commonRef.value.errorDisplayTransitionControl(response);

                return;
            }
        }

        /**
         * ファイル選択画面へ遷移する
         * 
         */
        function navigationUpload() {
            // ファイル選択画面へ遷移する
            router.push('/bulk-add-users/upload');
        }

        return {
            stepper,
            state,
            commonRef,
            outputPasswords,
            navigationUpload,
            fileName
        };
    }
});
